import learningApi from '../../../api/learning/learning.js'
import QuestionListApi from '../../../api/questions/questions.js'

const state = {
    lesson_info: {},
    show_publish_dialog: false,
    show_content_tag: {
        show_description: true,
        show_question: false,
        show_summary: false,
    }
}
const getters = {}

const mutations = {
    change_course_information(state, lesson_info) {
        state.lesson_info = lesson_info
    },
    change_show_content(state, args) {
        if (args == 'description') {
            state.show_content_tag = {
                show_description: true,
                show_question: false,
                show_summary: false,
            }
        }
        if (args == 'question') {
            state.show_content_tag = {
                show_description: false,
                show_question: true,
                show_summary: false,
            }
        }
        if (args == 'summary') {
            state.show_content_tag = {
                show_description: false,
                show_question: false,
                show_summary: true,
            }
        }
    },
    change_pubilsh_dialog(state, args) {
        if (args == 'open') {
            state.show_publish_dialog = true
        }
        if (args == 'close')
            state.show_publish_dialog = false
    },
    add_question(state, args) {
        state.lesson_info.questions.unshift(args)
    },
    show_lesson_or_my_question(state, args){
        state.lesson_info.questions = args
    }
}

const actions = {
    get_and_change_lesson_info(context, args) {
        learningApi.get_lesson_info(args.courseId, args.lessonId).then(function (lesson_info) {
            context.commit('change_course_information', lesson_info.data)
        })
    },
    change_show_content(context, args) {
        context.commit('change_show_content', args)
    },
    change_pubilsh_dialog(context, args) {
        context.commit('change_pubilsh_dialog', args)
    },
    add_question(context, args) {
        context.commit('add_question', args)
    },
    show_lesson_or_my_question(context, args) {
        QuestionListApi.get_lesson_or_my_question_list(args).then(function (res) {
           context.commit('show_lesson_or_my_question', res.data)
        })
    }

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
